NtechApp.ResumeSettingsForm = function() {
    var me = this;

    this._ajax = null;
    this._click = null;
    this._form = null;
    this._isSaving = false;

    this._resumeViewTypeRadio = null;

    this._construct = function () {
        me._ajax = new NtechApp.Ajax();
        me._click = new NtechApp.TouchClickEvent();
        me._form = new NtechApp.ModalForm();

        me._bindEvents();
    }

    this._bindEvents = function () {
    }

    this._unbindEvents = function () {
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.proto(NtechApp.ResumeSettingsForm, {
    disableLoaders: function() {
        this._form.disableLoaders();
    },

    loadForm: function(afterSaveCb) {
        var me = this;

        this._form.load("personal_dashboard_load_resume_settings_form", function($form) {
            me._resumeViewTypeRadio = new NtechApp.RadioBox(
                $form.find('[data-customRadioId="viewResumeType"]')
            );

            me._click.listen($form.find("[data-confirmBut]"), function(e) {
                if(me._isSaving) return;
                me._isSaving = true;

                var $control = $(e.target).closest("[data-confirmBut]");
                me._savePrivacySettings($form, $control, afterSaveCb);
            });
        });
    },

    unloadForm: function() {
        this._form.unload();
    },

    _savePrivacySettings: function($form, $control, afterSaveCb) {
        var me = this;
        $control.text("");
        me._ajax.enableTextLoading($control);

        this._ajax.post({
            url: Routing.generate('personal_dashboard_save_resume_settings_form'),
            data: {
                viewResumeType: me._resumeViewTypeRadio.val()
            },
            onSuccess: function(res) {
                afterSaveCb();

                me.unloadForm();
                me._isSaving = false;
            }
        });
    }
});